import classNames from 'classnames';

import { css } from '@sorare/css';

import { Sport } from '#src/__generated__/globalTypes.ts';
import { FootballLogo } from '#src/atoms/icons/FootballLogo.tsx';
import { MLBLogo } from '#src/atoms/icons/MLBLogo.tsx';
import { NBALogo } from '#src/atoms/icons/NBALogo.tsx';
import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconChevronDown } from '#src/atoms/icons/system/iconChevronDown.ts';
import { iconChevronUp } from '#src/atoms/icons/system/iconChevronUp.ts';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { Ellipsis } from '#src/atoms/typography/Ellipsis/index.tsx';
import { LabelM } from '#src/atoms/typography/index.tsx';
import { Avatar } from '#src/components/user/Avatar/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useIsLaptop } from '#src/hooks/device/useIsLaptop.ts';
import { laptopAndAbove } from '#src/style/mediaQuery.ts';

const root = css`
  position: relative;
  padding: var(--half-unit);
  border-radius: var(--triple-unit);
  margin-left: calc(-1 * var(--half-unit));

  @media ${laptopAndAbove} {
    margin-left: 0;
  }

  &:hover {
    background-color: var(--c-surface-primary);
  }
`;
const sportIcon = css`
  position: absolute;
  right: 0;
  bottom: 0;

  border: 2px solid var(--c-black);
  border-radius: 50%;
  width: var(--triple-unit);
  height: var(--triple-unit);
  &.small {
    width: var(--double-and-a-half-unit);
    height: var(--double-and-a-half-unit);
  }
`;

const sportIcons = {
  [Sport.FOOTBALL]: <FootballLogo />,
  [Sport.BASEBALL]: <MLBLogo />,
  [Sport.NBA]: <NBALogo />,
};

type Props = { sport: Sport; active?: boolean; size?: 'small' | 'medium' };
export const ProfileButtonContent = ({
  sport,
  active,
  size = 'medium',
}: Props) => {
  const { currentUser } = useCurrentUserContext();
  const isLaptopAndAbove = useIsLaptop();

  if (!currentUser) {
    return null;
  }

  if (!isLaptopAndAbove) {
    return (
      <Horizontal className={root} gap={1.5} center>
        <Avatar user={currentUser} rounded size={size === 'small' ? 4 : 5} />
        <Horizontal center className={classNames(sportIcon, size)}>
          {sportIcons[sport]}
        </Horizontal>
      </Horizontal>
    );
  }

  return (
    <Horizontal className={root} gap={1.5} center>
      <Avatar user={currentUser} rounded size={4} />
      <Ellipsis>
        <LabelM bold>{currentUser.nickname}</LabelM>
      </Ellipsis>
      <FontAwesomeIcon icon={active ? iconChevronUp : iconChevronDown} />
    </Horizontal>
  );
};
